import { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

export const pricingRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import('./management/PricingManagementRoute').then((m) => ({
        Component: m.PricingManagementRoute,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/pricing/" linkText="Go back to pricing" />
    ),
  },
];
